import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ProduitsComponent } from './pages/produits/produits.component';
import { CommandesComponent } from './pages/commandes/commandes.component';
import { UtilisateursComponent } from './pages/utilisateurs/utilisateurs.component';
import { environment } from '../environments/environment';

const qaRoutes: Routes = [
  ...('qa' in environment && environment.qa ? [
    {
      path: 'test-notifications',
      loadComponent: () => import('./pages/test-notifications/test-notifications.component').then(m => m.TestNotificationsComponent)
    }
  ] : [])
];

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'produits',
        component: ProduitsComponent
      },
      {
        path: 'commandes',
        component: CommandesComponent
      },
      {
        path: 'utilisateurs',
        component: UtilisateursComponent
      },
      ...qaRoutes
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
